/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkmarks/completed': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 110 16A8 8 0 018 0zm3.737 6.202a.674.674 0 00-.97.007L7.481 9.54 5.899 7.94a.68.68 0 00-.97 0l-.061.063a.697.697 0 000 .98l2.124 2.147a.68.68 0 00.97 0l3.837-3.885a.697.697 0 000-.98z" _fill="#000" fill-rule="evenodd"/>'
  }
})
